export {
  getEmailTemplates,
  getEmailTemplatesList,
  getEmailLogo,
  getEmailTemplate
} from './queries';

export { updateEmailTemplate } from './mutations';
